import Vue from 'vue'
import store from '../store';
import VueRouter from 'vue-router';

Vue.use(VueRouter)

  const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/Login.vue'),
    meta: { noLayout: true }
  },
  {
    path: '/account/confirm',
    component: () => import('../views/ConfirmAccount.vue')
  },
  {
    path: '/account/reset',
    component: () => import('../views/ResetPassword.vue'),
    meta: { noLayout: true }
  },

  {
    path: '/department',
    component: () => import('../views/DepartmentList.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/department/add',
    component: () => import('../views/DepartmentAdd.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/educationtype',
    component: () => import('../views/EducationTypeList.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/educationtype/add',
    component: () => import('../views/EducationTypeAdd.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/educationtype/:id',
    component: () => import('../views/EducationType.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/department/:id',
    component: () => import('../views/Department.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/company',
    component: () => import('../views/CompanyList.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/company/add',
    component: () => import('../views/CompanyAdd.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/company/:id',
    component: () => import('../views/Company.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/person/add',
    name: 'addUser',
    component: () => import('../views/PersonAdd.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/person',
    component: () => import('../views/PersonList.vue'),
    meta: { requiresAuth: true },
    alias: '/'
  },
  {
    path: '/person/:id',
    name: 'editUser',
    component: () => import('../views/Person.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/companyfiletype',
    component: () => import('../views/CompanyFileType.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/education',
    component: () => import('../views/Education.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/notifications',
    component: () => import('../views/Notification.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '*',
    component: () => import('../views/404.vue'),
    meta: { noLayout: true }
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if(to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      next()
      return
    }
    next('/login') 
  } else {
    if (store.getters.isLoggedIn) {
      next('/person')
    } else {
      next() 
    }
  }
})

export default router
